import type { CustomFlowbiteTheme } from 'flowbite-react';

export const textareaTheme: CustomFlowbiteTheme['textarea'] = {
  base: 'block w-full border disabled:cursor-not-allowed disabled:opacity-50 text-sm',
  colors: {
    gray: 'border-titan-night-300 text-titan-night-900 focus:border-titan-folly-500 focus:ring-titan-folly-500',
    info: 'border-titan-blue-500 bg-titan-blue-50 text-titan-blue-900 placeholder-titan-blue-700',
    failure:
      'border-titan-folly-500 bg-titan-folly-50 text-titan-folly-900 placeholder-titan-folly-700 focus:border-titan-folly-500 focus:ring-titan-folly-500',
    warning:
      'border-titan-yellow-500 bg-titan-yellow-50 text-titan-yellow-900 placeholder-titan-yellow-700 focus:border-titan-yellow-500 focus:ring-titan-yellow-500',
    success:
      'border-green-500 bg-green-50 text-green-900 placeholder-green-700 focus:border-green-500 focus:ring-green-500',
  },
  withShadow: {
    on: 'shadow-sm',
    off: '',
  },
};
